import { render, staticRenderFns } from "./WorkorderLayoutRow.vue?vue&type=template&id=704923ba&scoped=true&"
import script from "./WorkorderLayoutRow.vue?vue&type=script&lang=js&"
export * from "./WorkorderLayoutRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704923ba",
  null
  
)

export default component.exports